import { MoreOutlined } from "@ant-design/icons"
import { Button, Card, Dropdown, Flex, Tag, Typography } from "antd"
import type { MenuItemType } from "antd/es/menu/interface"
import React from "react"
import { useTranslation } from "react-i18next"

import type { AlbumListItem } from "../../../../../../Album/types/album.types.ts"
import { AlbumThumbnails } from "./AlbumThumbnails.tsx"

const { Text } = Typography

interface AlbumCardProps {
  album: AlbumListItem
  onView?: (id: string) => void
  actions: MenuItemType[]
}

export const AlbumCard = ({ album, onView, actions }: AlbumCardProps) => {
  const { t } = useTranslation()
  const count = album?.attachments_count || 0
  const created = album?.created

  const onViewHandler = () => {
    onView?.(album?.id)
  }

  return (
    <Card
      onClick={onViewHandler}
      hoverable
      className="h-full cursor-pointer"
      styles={{ body: { padding: 0 } }}
    >
      <AlbumThumbnails attachments={album?.attachments} />

      <div className="p-2.5">
        <Flex justify="space-between" align="center" gap={4}>
          <Flex align="center" gap={4} className="min-w-0 flex-1">
            <Text
              ellipsis={{ tooltip: album?.name }}
              strong
              className="min-w-0"
            >
              {album?.name}
            </Text>
            {album.created_by_is_customer && (
              <Tag color="blue" className="!m-0 !text-xs shrink-0">
                {album.created_by_name
                  ? t("files.filters.sharedByCustomerNamed", {
                      name: album.created_by_name
                    })
                  : t("files.filters.sharedByCustomer")}
              </Tag>
            )}
          </Flex>

          {actions.length > 0 && (
            <div onClick={(e) => e.stopPropagation()}>
              <Dropdown trigger={["click"]} menu={{ items: actions }}>
                <Button
                  type="text"
                  size="small"
                  className="shrink-0"
                  icon={<MoreOutlined />}
                  aria-label={t("files.albums.actions.menu", {
                    name: album?.name
                  })}
                />
              </Dropdown>
            </div>
          )}
        </Flex>

        <Text type="secondary" className="text-xs">
          {created} • {t("files.albums.fileCount", { count })}
        </Text>
      </div>
    </Card>
  )
}
